<template src="./registroSintesiPEFC.html"></template>

<script>
import CategoriePEFC from '@/components/registroSintesiPEFC/CategoriePEFC.vue'
import CommessePEFC from '@/components/registroSintesiPEFC/CommessePEFC.vue'
import MateriePrime from '@/components/registroSintesiPEFC/MateriePrime.vue'
import DeclassamentoMateriale from '@/components/registroSintesiPEFC/DeclassamentoMateriale.vue'
import EsportaDati from '@/components/registroSintesiPEFC/EsportaDati.vue'

import { get_log_commesse, get_materiali, get_verifica_accesso } from '@/api/api.registroSintesiPEFC.js'

export default {
    components: {
        CategoriePEFC,
        CommessePEFC,
        MateriePrime,
        DeclassamentoMateriale,
        EsportaDati,
    },

    data() {
        return {
            tab: 0,
            showCategorie: false,       //dialog anagrafica categorie PEFC
            showCommessa: false,        //dialog inserimento e modifica commesse
            showMatPrima: false,        //dialog inserimento e modifica materie prime

            search: '',
            datiCommesse: [],
            headersCommesse: [
                { text: 'ID', value: 'ID' },
                { text: 'Riferimento', value: 'Riferimento' },
                { text: 'Cliente', value: 'ClienteUscita' },
                { text: 'Gruppi di prodotto', value: 'GruppiProdotto' },
                { text: 'Essenze', value: 'Essenze' },
                { text: 'Dichiarazioni PEFC', value: 'DichiarazioniPEFC' },
                /* { text: 'Essenza', value: 'essenza' }, */
                { text: 'Terzisti', value: 'Terzisti' },
                { text: 'Azioni', value: 'actions' },
            ],
            elementoSel: {},

            materiaSel: {},
            headersMatPrime: [
                { text: 'Codice', value: 'idMateriale' },
                { text: 'Fornitore', value: 'fornitore' },
                { text: 'DDT', value: 'nBollaText' },
                { text: 'Fattura', value: 'nFatturaText' },
                { text: 'Gruppo di prodotto', value: 'gruppoCategoriaPEFC' },
                { text: 'Essenza', value: 'essenza' },
                { text: 'Dichiarazione PEFC', value: 'dichiarazionePEFC' },
                { text: 'Unità Misura', value: 'um' },
                { text: 'QTA', value: 'qta' },
                { text: 'Descrizione', value: 'descrizione' },
                { text: 'Azioni', value: 'actions' },
            ],

            datiMatPrime: [],

            companyCode: "",
            cliente: "",

            dialogDeclassamento: false,
            dialogDownload: false,
        }
    },

    methods: {
        indietro() {
            if (this.role !== "utente")
                this.$router.push({ path: "/registro-pefc" });
            else
                this.$router.push({ path: "/" });
        },

        async caricaDati() {
            if (this.tab === 0) {
                await this.caricaDatiMatPrime();
            } else if (this.tab === 1) {
                await this.caricaDatiCommesse();
            }
        },

        //#region Commesse

        apriDialogCommesse(item = null) {
            if (!item) {
                this.elementoSel = {
                    CompanyCode: this.companyCode,
                    IdCommessa: -1,
                    riferimento: '',
                    cliente: this.cliente,
                    ClienteUscita: '',
                    gruppoProdotto: '',
                    dichiarazionePEFC: '',
                    essenza: '',
                    Qta: 0,
                    Ddt: [],
                    Fatture: [],
                    TerzistiInv: [],
                    TerzistiRic: [],
                    Sezioni: [],
                };
            } else {
                this.elementoSel = { ...item };
            }
            this.showCommessa = true;
        },

        async caricaDatiCommesse() {
            let par = "";
            if (this.role !== "utente")
                par = "?companyCode=" + this.companyCode;
            let res = await get_log_commesse(par);
            this.datiCommesse = res.data;
        },

        chiudiCommessa(aggiorna = false) {
            this.showCommessa = false;
            if (aggiorna) {
                this.caricaDatiCommesse();
            }
            this.elementoSel = {};
        },

        //#endregion

        //#region Materie Prime
        async caricaDatiMatPrime() {
            let par = "";
            if (this.role !== "utente")
                par = "?companyCode=" + this.companyCode;
            let res = await get_materiali(par);
            this.datiMatPrime = res.data;
        },

        duplicaRigo(item) {
            let itemDup = { ...item };
            itemDup.idMateriale = -1;
            this.apriDialogMatPrima(itemDup);
        },

        apriDialogMatPrima(item = null) {
            if (!item) {
                this.materiaSel = {
                    CompanyCode: this.companyCode,
                    IdMateriale: -1,
                    Fornitore: '',
                    NBolla: '',
                    DataBolla: '',
                    NFattura: '',
                    DataFattura: '',
                    GruppoCategoriaPEFC: '',
                    Essenza: '',
                    DichiarazionePEFC: '',
                    Um: '',
                    Qta: 0,
                    Descrizione: '',
                    Pezzi: 0,
                    Sezione: 0,
                    Spessore: 0,
                    Lunghezza: 0,
                };
            } else {
                this.materiaSel = { ...item };

                if (this.materiaSel.DataBolla)
                    this.materiaSel.DataBolla = this.materiaSel.DataBolla.substring(0, 10);

                if (this.materiaSel.DataFattura)
                    this.materiaSel.DataFattura = this.materiaSel.DataFattura.substring(0, 10);
            }
            this.showMatPrima = true;
        },


        chiudiMatPrima(aggiorna = false) {
            this.showMatPrima = false;
            if (aggiorna) {
                this.caricaDatiMatPrime();
            }
            this.materiaSel = {};
        },

        //#endregion

        //#region Declassamento materiale

        apriDialogDeclassamento() {
            this.dialogDeclassamento = true;
        },

        chiudiDialogDeclassamento() {
            this.dialogDeclassamento = false;
        },
        //#endregion

        esportaDati() {
            this.dialogDownload = true;
        },

        chiudiEsporta() {
            this.dialogDownload = false;
        },

        async verificaAziendaUrl() {
            // Al primo caricamento diretto della pagina (es. url incollato in barra indirizzi)
            // il ruolo utente puo' non essere ancora stato caricato in store (richiesta
            // asincrona avviata da Main.vue): senza attenderlo i controlli sotto verrebbero
            // saltati (this.role vuoto) lasciando la pagina accessibile senza verifica.
            if (!this.role) {
                await this.$store.dispatch("user/userInfo");
            }

            this.companyCode = this.$route.params.codice || null;

            // Un utente cliente non deve mai poter vedere/operare su un'altra azienda modificando
            // il codice nell'URL: se non corrisponde alla propria azienda, si forza quest'ultima
            // e si corregge l'indirizzo, invece di fidarsi di quanto scritto nell'URL.
            if (this.role === "utente" && this.companyCode !== this.miaAzienda) {
                this.companyCode = this.miaAzienda;
                this.$router.replace({ path: "/registro-pefc/" + this.miaAzienda }).catch(() => { });
                return;
            }

            // Un auditor puo' vedere solo le aziende a cui e' stato assegnato: se prova ad accedere
            // ad un'altra azienda modificando il codice nell'URL, viene rimandato all'elenco.
            if (this.role === "auditor" && this.companyCode) {
                let res = await get_verifica_accesso(this.companyCode);
                if (!res.data) {
                    this.$router.replace({ path: "/registro-pefc" }).catch(() => { });
                    return;
                }
            }

            if (this.companyCode) {
                this.cliente = this.$route.query.cliente || "";

                // Link "apri commessa" dalla pagina Storico Output: apre direttamente la commessa in modifica
                const apriCommessa = this.$route.query.apriCommessa;
                if (apriCommessa) {
                    this.tab = 1;
                    await this.caricaDatiCommesse();
                    const item = this.datiCommesse.find((c) => String(c.ID) === String(apriCommessa));
                    if (item) this.apriDialogCommesse(item);
                    else this.$toast.alert("Commessa non trovata");
                } else {
                    this.caricaDati();
                }
            } else {
                this.$router.push({ path: "/" });
            }
        },
    },

    mounted() {
        this.verificaAziendaUrl();
    },

    computed: {
        role() {
            return this.$store.getters['user/getRole'];
        },

        miaAzienda() {
            return this.$store.getters['user/getCompanyCode'];
        },
    },

    watch: {
        tab() {
            this.caricaDati();
        },

        // copre anche il caso (raro con lo history mode del router) in cui il parametro :codice
        // cambi senza un ricaricamento completo della pagina, che ometterebbe mounted()
        '$route.params.codice'() {
            this.verificaAziendaUrl();
        },
    }
}
</script>